import { CAR_SUBCAT_MAPPING, getEscrowDetails } from '../constants/postad';
import config from '../../../config';

export const CATEGORY_ICON_MAPPING = {
  179: 'entertainment',
  123: 'services',
  93: 'jobs',
  40: 'home_lifestyle',
  60: 'cars',
  20: 'homes',
  1: 'community',
  161: 'matrimonial',
  194: 'education',
  246: 'pets_pet_care',
  247: 'appliances_acs',
  269: 'mobiles_tablets',
  281: 'events'
};

export const FormatInput = (key, data) => {
  let response = {};
  switch (key) {
    case 'cars_bikes':
      response.isinsured = !!data.insurance_validity;
      break;
    default:
      break;
  }
  response = Object.keys(response).reduce((res, key) => ({ ...res, [key]: response[key] }), {});
  return response;
};


export const getOldPostAdHref = mGlobal => {
  const { catName, title, catId } = CAR_SUBCAT_MAPPING[mGlobal] || getEscrowDetails(mGlobal);
  return `${config.DOMAIN}/${catName}/${title}/?postadcategoryid=${catId}`;
}

export const getOldEditAdHref = adId => {
  return `${config.DOMAIN}/cars-bikes/edit-ad/?adId=${adId}`;
}